// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yyWrW{width:100%;flex-wrap:wrap}.blXhc{flex:0 0 220px;width:220px;display:flex;flex-direction:column}.EZjrQ{flex:1;width:100%;min-height:120px}.c_W1D{margin-top:auto}.lpG07{flex:1;min-width:200px;display:flex;align-items:stretch;justify-content:center}.dXXCL button{width:44px;height:44px}.iezm0{width:100%}.kReOi{width:100%}.Zs6Mr{flex:none;width:100%;height:140px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `yyWrW`,
	"leftColumn": `blXhc`,
	"logoPickerWrapper": `EZjrQ`,
	"colorsWrapper": `c_W1D`,
	"previewWrapper": `lpG07`,
	"colorSelectors": `dXXCL`,
	"columnRoot": `iezm0`,
	"columnPreviewWrapper": `kReOi`,
	"columnLogoWrapper": `Zs6Mr`
};
export default ___CSS_LOADER_EXPORT___;
